import React, { useEffect, useRef, useState } from 'react'
import cogoToast from 'cogo-toast-react-17-fix';

import API from '.././../../../ApiConfig'
import { GET_ALL_DOCS_ISSUER_ID, GET_DEFAULT_FIELDS, GET_DISTINCT_ISSUER, VERIFIER_SEARCH, HOLDER_CONSENT, BASE_URL, USER_TOKEN, DOCUMENT_PREVIEW, GET_DISCREPANCY_BY_TICKET_FOR_ISSUER } from '../../../../Utils/constant'
import { BUTTONS, MESSAGE } from '../../../../Utils/Strings';
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';
import ReactPortalModal from '../../../../components/ReactPortalModal';

import TopTitleBar from '../TopTitleBar'
import ShimmerLoader from '../../../../components/ShimmerLoader';
import styles from './ChangeRequest.module.css'
import { EMAIL_CHECK, IssuerDate, NAME_CHECK, _ToNormal, convertDateFormat, setDate } from '../../../../Utils/helper';
import useRefreshToken from '../../../../Hooks/usegenerateToken';
import { useSelector } from 'react-redux';
import TextBox from '../../../../components/Inputs/TextBox';
import PreviewModal from '../../../../components/DashBoard/ChangeRequest/PreviewModal';
import RequestedDocFields from '../../../../components/DashBoard/ChangeRequest/docFieldTable';
import DenyRequest from '../../../../components/DashBoard/ChangeRequest/DenyRequest';
import ViewRequestedChanges from '../../../../components/DashBoard/ChangeRequest/viewChangeRequest';
import { useParams } from 'react-router-dom';
import Error from '../../../../components/OnBoard/Error';
import Icon from 'react-icons-kit';
import { eye } from 'react-icons-kit/typicons/eye'


export default function ChangeRequest() {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const userData = useSelector(state => state.User)
    let { docID } = useParams();


    const [Loading, setloading] = useState(false);
    const [data, setData] = useState([])

    const [comment, setcomment] = useState('')
    const [docFields, setDocFields] = useState([])
    const addDocValue = (index, value) => {
        setDocFields((prevDocFields) =>
            prevDocFields.map((field, i) =>
                i === index ? { ...field, estimated_correct_value: value } : field
            )
        );
    }

    useEffect(() => {
        setloading(true)
        API.get(GET_DISCREPANCY_BY_TICKET_FOR_ISSUER + docID)
            .then(res => {
                setData(res.data.data)
                setDocFields(res.data.data.discrepancy_log_data.details)
                // console.log(data)
            })
            .catch(err => {
                if (err?.response)
                    cogoToast.error(err.response.data.message)
                else
                    cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
                setData(1)
            })
            .finally(() => setloading(false))

    }, [])


    // Display supporting document PDF
    const [preview, setPreview] = useState(null)
    const [loadingText, setLoadingText] = useState('Genrating PDF... Please Wait')
    const [pdfLoading, setPDFloading] = useState(null)
    const getPdf = (item, index) => {
        setPDFloading(index)
        API.get(DOCUMENT_PREVIEW + item.supporting_document_id)
            .then(response => {
                setPDFloading(null)
                setPreview(response.data.data.pdf);
            }).catch(err => {
                setPDFloading(null);
                setPreview(null)
                setLoadingText("Error while generating PDF");
            })
    }

    const DocPreview = () => {
        var loading = {
            padding: "1rem",
            height: "10vh",
            width: "-webkit-fill-available",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
        if (!preview) {
            return (<div style={loading}>
                {loadingText}
            </div>)
        }
        else {
            return (
                <embed
                    id="pdf-viewer"
                    src={preview + "#toolbar=0"}
                    type="application/pdf"
                />
            )
        }
    }

    // select doc fields to edit
    const [ischecked, setChecked] = useState([])

    const checkField = (i) => {
        setChecked((prev) => {
            if (prev.includes(i)) {
                return prev.filter((e) => e !== i);
            } else {
                return [...prev, i];
            }
        });
    }


    // submit Data
    const [issubmit, setsubmit] = useState(false)
    const [isDeny, setDeny] = useState(false)
    const [submitData, setSubmitData] = useState(data)
    const SubmitData = () => {
        if (ischecked.length < 1) {
            cogoToast.info("Please select some fields to continue")

        }
        else if ((ischecked.length != data.discrepancy_log_data.details.length) && (comment == null || comment == '')) {
            cogoToast.info("Please add some comment")
        }
        else {
            const formatData = () => {
                const filteredData = docFields
                    .filter(item => ischecked.includes(item.doc_field_id))
                    .map(({ doc_field_id, estimated_correct_value }) => ({
                        doc_field_id,
                        issuer_value: estimated_correct_value,
                    }));
                return filteredData
            }
            let submitdata = {
                accept_doc_fields: formatData(),
                selected: ischecked,
                comment

            }
            setSubmitData(submitdata)
            setsubmit(true)

        }

    }

    if (data == 1) {
        return <Error Message="No Such Descrepency log" />
    }

    return (
        <SlideUpWrapper direction="slide-right">
            <div className='topTitleBar' style={{ marginBottom: "-1rem" }}>
                <div className="topTitleBarTextContainer" style={{ textAlign: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span className={[styles.status, styles[data.status]].join(" ")}>
                            Request {data.status}
                        </span>
                        <h2 className="topTitleBarText" style={{ alignSelf: 'flex-start' }}>
                            <span className="secondaryButton1">{data?.holder_name} : {data.issued_document_name}</span>
                        </h2>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <span>
                                Requested on : {setDate(data.created_at)}
                            </span>
                            <span>
                                Request ID :  {data.discrepancy_ticket_id}
                            </span>
                        </div>
                    </div>
                    <div>
                        <button
                            className='btn'
                            style={{ display: 'flex', alignItems: 'center' }}
                            onClick={e => {
                                if (!pdfLoading)
                                    getPdf({ supporting_document_id: data.old_issued_document_id }, 9)
                            }}
                        >{pdfLoading == 9 ? 'Opening Document..' : <><Icon icon={eye} size={'1.3rem'} />View Document</>}</button>
                    </div>

                </div>
                <section className={styles.searchBox} >
                    <h2 className='topTitleBarText'>
                        {data?.holder_name} has requested following changes
                    </h2>
                    <div className={styles.MainSearchContainer}>
                    </div>{
                        data.status == 'change' ? <>

                            <RequestedDocFields data={data} update={addDocValue} docfields={docFields} ischecked={ischecked} checkField={checkField} getPdf={getPdf} pdfLoading={pdfLoading} />
                            <div className={styles.comment}>
                                <span>
                                    Add Comment <span style={{color:"red"}}>*</span>
                                </span>
                                <TextBox placeholder={'Add comment'} onChange={setcomment} maxlength={255} />
                            </div>
                            <div className={styles.buttonBase}>
                                <button className={`btn  ${styles.accept}`} onClick={SubmitData}>{'Approve'}</button>
                                <button className={`btn  ${styles.reject}`} onClick={() => setDeny(true)}>{'Reject'}</button>
                            </div>
                        </> :
                            <ViewRequestedChanges data={data} />
                    }
                </section>
            </div>
            <ReactPortalModal title="Document Preview" isOpen={preview} onClose={e => setPreview(null)}>
                <DocPreview />
            </ReactPortalModal>

            <ReactPortalModal title="Document Preview before Submit" isOpen={issubmit} blockOutsideClick={true} onClose={e => setsubmit(null)}>
                <PreviewModal data={submitData} original={data} onClose={setsubmit} />
            </ReactPortalModal>

            <ReactPortalModal title="Add Rejection Reason" isOpen={isDeny} blockOutsideClick={true} onClose={e => setDeny(null)}>
                <DenyRequest onClose={setDeny} docID={docID} />
            </ReactPortalModal>
        </SlideUpWrapper>
    )
}
